// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const AuthModalRecord = require('client-v2/common/containers/auth-modal/record')
const { FeedStreamRecord } = require('client-v2/common/containers/feed/records')
const ProfileUserRecord = require('client-v2/user-profile/containers/profile-user/record')
const EnvRecord = require('client-v2/common/state/env/record')
const RouterRecord = require('client-v2/common/state/router/record')
const UserRecord = require('client-v2/common/state/user/record')
const {
  defaultReviver,
  listReviver,
  keyedReviver
 } = require('client-v2/common/state/revivers')
// Entry imports
const LinkModalRecord = require('client-v2/into-landing/containers/link-modal/record')
const SMSModalRecord = require('client-v2/into-landing/containers/sms-modal/record')

 class IntoLikerRecord extends Immutable.Record({
  'user_id': Number(),
  'display_name': String(),
  'photo_url': String(),
  username: String()
}) {
  // No methods
}

IntoLikerRecord.reviver = keyedReviver(IntoLikerRecord, {
  // No nested data structures
})

class IntoMetaRecord extends Immutable.Record({
  media: new Immutable.List(), // List of strings
  provider: new Immutable.Map()
}) {
  // No methods
}

IntoMetaRecord.reviver = keyedReviver(IntoMetaRecord, {
  media: defaultReviver,
  provider: defaultReviver
})

class IntoLandingArticleRecord extends Immutable.Record({
  count: Number(),
  description: String(),
  embedUrl: String(),
  hash: String(),
  hostname: String(),
  image: String(),
  likers: Immutable.List(),
  md5image: String(),
  'mixes_count': Number(),
  'mixers_count': Number(),
  meta: null,
  thumbnail: String(),
  title: String(),
  type: String(),
  url: String(),
  'url_id': String(),
  'url_hash': String()
}) {
  // No methods
}

// Record Revivers
IntoLandingArticleRecord.likersReviver = listReviver(IntoLikerRecord.reviver)
IntoLandingArticleRecord.metaReviver = IntoMetaRecord.reviver
IntoLandingArticleRecord.reviver = keyedReviver(IntoLandingArticleRecord, {
  likers: IntoLandingArticleRecord.likersReviver,
  meta: IntoLandingArticleRecord.metaReviver
})

class IntoLandingFeedItemRecord extends Immutable.Record({
  article: null
}){
  // No methods
}

IntoLandingFeedItemRecord.reviver = keyedReviver(IntoLandingFeedItemRecord, {
  article: IntoLandingArticleRecord.reviver
})

class IntoLandingRootRecord extends Immutable.Record({
  // Common state
  env: null,
  router: null,
  user: null,
  // Entry containers
  articleProfile: null,
  authModal: null,
  feed: null,
  linkModal: null,
  posterUrl: String(),
  profileUser: null,
  smsModal: null,
  videoUrl: String()
}) {
  // No methods
}

IntoLandingRootRecord.reviver = keyedReviver(IntoLandingRootRecord, {
  // Common state
  env: EnvRecord.reviver,
  router: RouterRecord.reviver,
  user: UserRecord.reviver,
  // Entry containers
  articleProfile: IntoLandingArticleRecord.reviver,
  authModal: AuthModalRecord.reviver,
  feed: FeedStreamRecord.reviver,
  linkModal: LinkModalRecord.reviver,
  posterUrl: defaultReviver,
  profileUser: ProfileUserRecord.reviver,
  smsModal: SMSModalRecord.reviver,
  videoUrl: defaultReviver
})

module.exports = IntoLandingRootRecord
